/**
 * A patient certification is an option built from one of the store's certification option
 * templates, which is what `certification_family` reports. Certifications created before
 * templates were used carry no group and are recognised by their `option_title_id` instead.
 *
 * Both checks are needed: a product can hold either kind, and neither can be told from an
 * ordinary option by its title.
 */
export const isCertificationOption = (option): boolean => Boolean(
  option?.certification_family || option?.option_title_id?.includes('certification')
);
